import { FaArrowRightLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FarmGallery = () => {
  const { t } = useTranslation();
  const images = [
    { id: 1, src: "/sss.webp", alt: "sustain1", span: "row-span-2" },
    { id: 2, src: "/screen-mobile.webp", alt: "sustain2", span: "" },
    { id: 3, src: "/sustain10.png", alt: "sustain3", span: "row-span-2" },
    { id: 4, src: "/display.webp", alt: "sustain4", span: "" },
    { id: 5, src: "/poly.webp", alt: "sustain5", span: "" },
    { id: 6, src: "/sustain11.jpeg", alt: "sustain6", span: "" },
  ];

  return (
    <section className="bg-white py-10">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="text-center mb-12 px-5 sm:px-0">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t("sustainability_heading")}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t("sustainability_text")}
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 px-3 sm:px-0 auto-rows-[240px]">
          {images.map((image) => (
            <div
              key={image.id}
              className={`${image.span} rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] cursor-pointer group relative bg-gray-100`}
            >
              <img
                src={image.src}
                alt={image.alt}
                width={400}   // approximate width
                height={240}  // approximate height
                loading="lazy"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).src = "/fallback.jpg";
                }}
                className="w-full h-full object-cover object-center group-hover:brightness-90 transition-all duration-300"
              />
            </div>
          ))}
        </div>

        {/* Button */}
        <div className="flex justify-center mt-12 px-5 sm:px-0">
          <Link
            to="/portfolio"
            className="group relative inline-flex items-center px-8 py-4 bg-[#7EDE56] text-[#002F3F] font-semibold text-lg rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105"
          >
            <span className="relative z-10 flex items-center gap-3 group-hover:text-white transition-colors duration-300">
              {t("sustainability_cta")}
              <FaArrowRightLong className="transition-transform duration-300 group-hover:translate-x-2" />
            </span>
            <div className="absolute inset-0 bg-[#002F3F] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
          </Link>
        </div>

      </div>
    </section>
  );
};

export default FarmGallery;